export const clock = () => (
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M12 7v5l3.333 1.667m5-1.667a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0"
  />
);
